import * as API from "@/store/actions/axios-api-instance";

export default async function updateProfile({state, commit}, data) {
    try {
        commit('SET_LOADING', true)
        const {profile} = state
        await API.saveProfile(data)
        commit('SET_PROFILE', {...profile, ...data})
        commit('SET_LOADING', false)
    } catch (e) {
        console.log(e)
        commit('SET_LOADING', false)
        if (e.response && e.response.data) {
            commit('SET_ERROR', e.response.data.join(' '))
        } else {
            commit('SET_ERROR', e.message)
        }
        throw e
    }
}